import React from 'react';

/**
 * Text Field SVG ELEMENT
 */
export default function TextFieldsSVG(): JSX.Element {
  return (
    <svg
      width='28'
      height='32'
      viewBox='0 0 28 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <mask id='path-1-inside-1' fill='white'>
        <path d='M0 4C0 1.79086 1.79086 0 4 0H28V32H4C1.79086 32 0 30.2091 0 28V4Z' />
      </mask>
      <path
        d='M0 0H28H0ZM28 32H0H28ZM0 32V0V32ZM29 0V32H27V0H29Z'
        fill='#CFD9E9'
        mask='url(#path-1-inside-1)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.979 10.1673C5.979 9.87967 6.21219 9.64648 6.49984 9.64648H15.6665C15.9542 9.64648 16.1873 9.87967 16.1873 10.1673V11.1673C16.1873 11.455 15.9542 11.6882 15.6665 11.6882C15.3789 11.6882 15.1457 11.455 15.1457 11.1673V10.6882H11.1873V21.3132H13.1665C13.4542 21.3132 13.6873 21.5463 13.6873 21.834C13.6873 22.1216 13.4542 22.3548 13.1665 22.3548H8.1665C7.87886 22.3548 7.64567 22.1216 7.64567 21.834C7.64567 21.5463 7.87886 21.3132 8.1665 21.3132H10.1457V10.6882H7.02067V11.1673C7.02067 11.455 6.78749 11.6882 6.49984 11.6882C6.21219 11.6882 5.979 11.455 5.979 11.1673V10.1673ZM14.3123 15.1673C14.3123 14.8797 14.5455 14.6465 14.8332 14.6465H21.4998C21.7875 14.6465 22.0207 14.8797 22.0207 15.1673V16.1673C22.0207 16.455 21.7875 16.6882 21.4998 16.6882C21.2122 16.6882 20.979 16.455 20.979 16.1673V15.6882H18.6873V21.3132H19.4165C19.7042 21.3132 19.9373 21.5463 19.9373 21.834C19.9373 22.1216 19.7042 22.3548 19.4165 22.3548H16.9165C16.6289 22.3548 16.3957 22.1216 16.3957 21.834C16.3957 21.5463 16.6289 21.3132 16.9165 21.3132H17.6457V15.6882H15.354V16.1673C15.354 16.455 15.1208 16.6882 14.8332 16.6882C14.5455 16.6882 14.3123 16.455 14.3123 16.1673V15.1673Z'
        fill='#254B86'
      />
    </svg>
  );
}
